<header class="header" id="header" #headerContentHeight>
  <!--NOTIFICATION BANNER-->
  <app-notification-banner></app-notification-banner>
  <!--END NOTIFICATION BANNER-->
  <!--TODO: Need to see if error component is need-->
  <!-- <app-error></app-error> -->
  <div class="wrapper">
    <div id="genesys-beyond-logo" class="beyond-logo-header">
      <a routerLink="/home" routerLinkActive="active">Genesys | Education</a>
    </div>

    <div id="genesys-header" class="header-options">
      <!--NAVIGATION-->
      <nav id="beyond-header-navigation" class="navigation">
        <ul class="explore-navigation">
          <li class="mega-drop-down margin-left-small">
            <a
              class="bold"
              [ngClass]="isExpandedProducts ? 'red' : ''"
              (click)="toggleMenu(headerMenu.PRODUCTS, $event)">
              {{ headerMenu.PRODUCTS }}
              <i
                class="icon x-small arrow-down"
                [ngClass]="isExpandedProducts ? 'arrow-rotate-up' : ''"></i>
            </a>
            <ng-container *ngIf="isExpandedProducts">
              <div class="mega-menu mega-menu-products menu-shadow">
                <div
                  class="padding-top-small padding-left-small padding-bottom-small padding-right-small">
                  <app-tile-layout maxColumns="3">
                    <ng-container
                      *ngFor="
                        let subscriptionItem of subscriptionItems;
                        let i = index;
                        trackBy: trackBySubscriptionItem
                      ">
                      <ng-container *ngIf="subscriptionItem?.canShowProductInMenu">
                        <li class="padding-left-small">
                          <h4 class="bolder">
                            <a
                              (click)="toggleMenu(headerMenu.PRODUCTS)"
                              href="/subscription/{{ subscriptionItem.slugName }}">
                              {{ subscriptionItem.displayName }} <i></i>
                            </a>
                          </h4>
                          <p>
                            {{ subscriptionItem.menuDescription }}
                          </p>
                        </li>
                      </ng-container>
                    </ng-container>
                    <div class="margin-left-small margin-top-small button-animate-white">
                      <button
                        routerLink="/products"
                        (click)="toggleMenu(headerMenu.PRODUCTS)"
                        href="javascript:void(0)"
                        class="btn btn-brand btn-medium">
                        View All Subscriptions
                      </button>
                    </div>
                  </app-tile-layout>
                </div>
              </div>
            </ng-container>
          </li>
          <li class="mega-drop-down margin-left-small">
            <a
              class="bold"
              [ngClass]="isExpandedCatalog ? 'red' : ''"
              (click)="toggleMenu(headerMenu.CATALOG, $event); clearStorage()">
              {{ headerMenu.CATALOG }}
              <i
                class="icon x-small arrow-down"
                [ngClass]="isExpandedCatalog ? 'arrow-rotate-up' : ''"></i>
            </a>
            <ng-container *ngIf="isExpandedCatalog">
              <div class="mega-menu menu-shadow">
                <div class="flexbox full-width">
                  <div class="mega-menu-column-small">
                    <ul class="border-right">
                      <li
                        class="padding-left-small padding-right-x-large padding-top-small"
                        [ngClass]="isOpenType ? 'active' : ''">
                        <div
                          class="sub-menu"
                          (mouseover)="toggleCatalog(filterMatchType.INSTRUCTION_TYPE)">
                          <div class="align-self-start">
                            <i class="icon regular blue icon-type"></i>
                          </div>
                          <div class="full-width margin-left-small padding-bottom-small">
                            <h4
                              class="full-width bolder flexbox flex-direction-row justify-space-between">
                              <a (click)="toggleCatalog(filterMatchType.INSTRUCTION_TYPE)">
                                Learning by Type
                              </a>
                              <i
                                class="icon x-small arrow-right-submenu"
                                [ngClass]="isOpenType ? 'red' : 'blue'"></i>
                            </h4>
                            <p>
                              Find your preferred type of course - instructor-led, self-study, or
                              eLearning
                            </p>
                          </div>
                        </div>
                      </li>
                      <li
                        class="padding-left-small padding-right-x-large padding-top-small"
                        [ngClass]="isOpenTopic ? 'active' : ''">
                        <div class="sub-menu" (mouseover)="toggleCatalog(filterMatchType.TOPIC)">
                          <div class="align-self-start">
                            <i class="icon regular blue icon-topic"></i>
                          </div>
                          <div class="full-width margin-left-small padding-bottom-small">
                            <h4
                              class="full-width bolder flexbox flex-direction-row justify-space-between">
                              <a (click)="toggleCatalog(filterMatchType.TOPIC)">
                                Learning by Topic
                              </a>
                              <i
                                class="icon x-small arrow-right-submenu"
                                [ngClass]="isOpenTopic ? 'red' : 'blue'"></i>
                            </h4>
                            <p>Find courses on the topics that interest you</p>
                          </div>
                        </div>
                      </li>
                      <li
                        class="padding-left-small padding-right-x-large padding-top-small"
                        [ngClass]="isOpenRole ? 'active' : ''">
                        <div class="sub-menu" (mouseover)="toggleCatalog(filterMatchType.ROLE)">
                          <div class="align-self-start">
                            <i class="icon regular blue icon-role"></i>
                          </div>
                          <div class="full-width margin-left-small padding-bottom-small">
                            <h4
                              class="full-width bolder flexbox flex-direction-row justify-space-between">
                              <a (click)="toggleCatalog(filterMatchType.ROLE)">
                                Learning by Role
                              </a>
                              <i
                                class="icon x-small arrow-right-submenu"
                                [ngClass]="isOpenRole ? 'red' : 'blue'"></i>
                            </h4>
                            <p>Find courses that are unique to your role</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <ng-container *ngIf="isOpenType">
                    <div
                      class="flexbox flex-direction-column justify-space-between margin-left-larger mega-menu-column-large margin-right-large">
                      <app-tile-layout maxColumns="3">
                        <li
                          *ngFor="
                            let learningType of learningTypeItems;
                            let i = index;
                            trackBy: trackByLearningTypeItem
                          ">
                          <a
                            class="catalog-sub-menu bolder"
                            (click)="filteredLearningTypeCatalog(learningType.value)">
                            {{ learningType.value }} <i></i>
                          </a>
                          <p>{{ learningType.menuDescription }}</p>
                        </li>
                      </app-tile-layout>
                      <ng-container *ngTemplateOutlet="viewFullCatalogButton"></ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isOpenTopic">
                    <div
                      class="flexbox flex-direction-column justify-space-between margin-left-larger mega-menu-column-large margin-right-large">
                      <app-tile-layout maxColumns="3">
                        <li
                          *ngFor="
                            let topic of topicItems;
                            let i = index;
                            trackBy: trackByTopicItem
                          ">
                          <a
                            class="catalog-sub-menu no-margin bolder"
                            (click)="filteredTopicCatalog(topic.value)">
                            {{ topic.value }} <i></i>
                          </a>
                          <p>{{ topic.menuDescription }}</p>
                        </li>
                      </app-tile-layout>
                      <ng-container *ngTemplateOutlet="viewFullCatalogButton"></ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isOpenRole">
                    <div
                      class="flexbox flex-direction-column justify-space-between margin-left-larger mega-menu-column-large margin-right-large">
                      <app-tile-layout maxColumns="3">
                        <li *ngFor="let role of roleItems; let i = index; trackBy: trackByRoleItem">
                          <ng-container *ngIf="role?.isMenuVisible">
                            <a
                              class="catalog-sub-menu bolder"
                              (click)="filteredRoleCatalog(role.value)">
                              {{ role.value }} <i></i>
                            </a>
                            <p>{{ role.menuDescription }}</p>
                          </ng-container>
                        </li>
                      </app-tile-layout>
                      <ng-container *ngTemplateOutlet="viewFullCatalogButton"></ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </li>
          <ng-container *ngIf="showMegaMenuResources">
            <li class="mega-drop-down margin-left-small">
              <a
                (click)="toggleMenu(headerMenu.RESOURCES, $event); clearStorage()"
                class="bold"
                [ngClass]="isExpandedResources ? 'red' : ''">
                {{ headerMenu.RESOURCES }}
                <i
                  class="icon x-small arrow-down"
                  [ngClass]="isExpandedResources ? 'arrow-rotate-up' : ''"></i>
              </a>
              <ng-container *ngIf="isExpandedResources">
                <div class="mega-menu mega-menu-resource menu-shadow">
                  <div class="margin-top-large margin-bottom-large">
                    <ul>
                      <ng-container
                        *ngFor="
                          let resource of resourceArray;
                          let i = index;
                          trackBy: trackByResourceName
                        ">
                        <ng-container *ngIf="resource.display">
                          <li class="padding-left-large padding-right-large">
                            <h4
                              class="full-width mega-title bolder flexbox flex-direction-row justify-space-between">
                              <a
                                (click)="toggleMenu(headerMenu.RESOURCES)"
                                routerLink="{{ resource.routerLink }}">
                                {{ resource.name }} <i></i
                              ></a>
                            </h4>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </div>
                  <ng-container *ngIf="isOpenLearningPath">
                    <div
                      class="flexbox flex-direction-column justify-space-between margin-left-larger mega-menu-column-large margin-right-large">
                      <app-tile-layout maxColumns="3">
                        <li
                          *ngFor="
                            let learningPath of learningPathItems;
                            let i = index;
                            trackBy: trackByLearningPathItem
                          "
                          class="padding-top-small padding-bottom-small">
                          <a class="bolder" routerLink="learning-path/{{ learningPath.slug }}">
                            {{ learningPath.value }} <i></i>
                          </a>
                          <p>{{ learningPath.menuDescription }}</p>
                        </li>
                      </app-tile-layout>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isOpenTrainingSupport">
                    <div class="mega-menu-column-large margin-left-larger margin-right-large">
                      <ul id="training-support-menu" class="flexbox full-width">
                        <li class="li-no-hover padding-left-small padding-top-small">
                          <a class="bolder" routerLink="training-support/getting-started">
                            Learning Subscriptions FAQs <i></i
                          ></a>
                          <ul>
                            <li class="padding-top-small">
                              <a routerLink="training-support/learning-subscription-how-to-enroll">
                                Learning Subscription: How to Enroll <i></i>
                              </a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/preparing-for-training">
                                Virtual Instructor-Led Training FAQs <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/self-study-faq">
                                Self-Study Courses FAQs <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/elearning-faqs">
                                eLearning FAQs <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/remote-access-tests">
                                Remote Access Tests <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/beyond-training-pre-check">
                                Education Training Pre-check <i></i
                              ></a>
                            </li>
                          </ul>
                        </li>
                        <li class="li-no-hover padding-left-small padding-top-small">
                          <a class="bolder" routerLink="training-support/getting-started">
                            Agent Training FAQS <i></i
                          ></a>
                          <ul>
                            <li class="padding-top-small">
                              <a routerLink="training-support/beyond-cx-faqs">
                                BeyondCX FAQs <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="training-support/agent-platform-ap-training-faqs">
                                Agent Platform (AP) Training FAQs <i></i
                              ></a>
                            </li>
                          </ul>
                        </li>
                        <li class="li-no-hover padding-left-small padding-top-small">
                          <a class="bolder" routerLink="training-support/getting-started">
                            eLearning <i></i
                          ></a>
                          <ul>
                            <li class="padding-top-small">
                              <a routerLink="genesys-cloud-cx-elearning">
                                Genesys Cloud eLearning <i></i
                              ></a>
                            </li>
                            <li class="padding-top-small">
                              <a routerLink="genesys-dx-elearning"> Genesys DX eLearning <i></i></a>
                            </li>
                            <li class="padding-top-small">
                              <a
                                routerLink="training-support/genesys-cloud-cx-digital-onboarding-guide">
                                Genesys Cloud Digital Onboarding Guide <i></i
                              ></a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="isOpenCertifications">
                    <div class="mega-menu-column-large margin-left-larger margin-right-large">
                      Certifications
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </li>
          </ng-container>
          <ng-container *ngIf="!showMegaMenuResources">
            <li class="mega-drop-down">
              <div class="header-controls header-support">
                <div class="dropdown">
                  <a
                    class="btn btn-transparent dropbtn border-none"
                    (click)="toggleMenu(headerMenu.RESOURCES, $event); clearStorage()">
                    <span class="brand bold" [ngClass]="isExpandedResources ? 'red' : ''">{{
                      headerMenu.RESOURCES
                    }}</span>
                    <i
                      class="icon red arrow-down x-small"
                      [ngClass]="isExpandedResources ? 'arrow-rotate-up' : ''"></i>
                  </a>
                  <ng-container *ngIf="isExpandedResources">
                    <ul class="dropdown-content header-options-menu margin-top-small">
                      <ng-container
                        *ngFor="
                          let resource of resourceArray;
                          let i = index;
                          trackBy: trackByResourceName
                        ">
                        <li
                          class="menu-item"
                          (click)="toggleMenu(headerMenu.RESOURCES); clearStorage()"
                          *ngIf="resource.display">
                          <a routerLink="{{ resource.routerLink }}">
                            <span>{{ resource.name }}</span>
                          </a>
                        </li>
                      </ng-container>
                    </ul>
                  </ng-container>
                </div>
              </div>
            </li>
          </ng-container>
        </ul>
        <ul class="explore-navigation action-navigation">
          <li class="header-actions">
            <!-- Search Input -->
            <app-search-input
              [searchPlaceholderMessage]="'Search catalog'"
              [hideSearchBlock]="true"
              (sendSearchQuery)="onSearch($event)"
              (inputValueChange)="onChangeQuery($event)"
              [searchQueryData]="query"></app-search-input>

            <!-- Log In Button -->
            <div class="button-animate-white" *ngIf="(claims$ | async) === null">
              <button routerLink="/login" class="btn btn-primary btn-small">Log In</button>
            </div>

            <!-- Sign Up Button -->
            <div class="button-animate-red" *ngIf="(claims$ | async) === null">
              <button (click)="sendToRegistration()" class="btn btn-inverse btn-small">
                Sign Up
              </button>
            </div>
            <!-- Google Translator Button -->
            <div class="language-translator" id="google_translate_element"></div>
          </li>

          <!--SIGNED IN USER MENU LINKS-->
          <li class="margin-left-small" *ngIf="claims$ | async as claims">
            <div class="header-controls">
              <div class="dropdown">
                <a
                  class="bold btn btn-transparent dropbtn"
                  (click)="toggleMenu(headerMenu.MY_DASHBOARD, $event)">
                  <span
                    *ngIf="currentUser && currentUser.avatarUrl"
                    [ngClass]="isExpandedDashboard ? 'red' : ''"
                    class="header-user-controls"
                    [style.background-image]="'url(' + currentUser.avatarUrl + ')'">
                    User Controls
                  </span>
                  <span
                    *ngIf="!currentUser || !currentUser.avatarUrl"
                    class="header-user-controls icon small avatar">
                    User Controls
                  </span>
                  <!--SHOW MESSAGE INBOX COUNT WITH AVATAR-->
                  <!--<span class="badge">{{ inboxCount }}</span>-->
                  <!--END SHOW MESSAGE INBOX COUNT WITH AVATAR-->
                  <i
                    class="icon x-small arrow-down red"
                    [ngClass]="isExpandedDashboard ? 'arrow-rotate-up' : ''"></i>
                </a>
                <!--USER MENU-->
                <ng-container *ngIf="isExpandedDashboard">
                  <div class="mega-menu mega-menu-dashboard margin-top-small menu-shadow">
                    <div class="margin-top-large margin-bottom-large">
                      <ul>
                        <ng-container
                          *ngFor="
                            let usermenu of userMenuArray;
                            let i = index;
                            trackBy: trackByUserMenu
                          ">
                          <li class="padding-left-large padding-right-large">
                            <h4
                              class="full-width mega-title bolder flexbox flex-direction-row justify-space-between">
                              <a
                                href="{{ usermenu.routerLink }}"
                                (click)="usermenu.clickEvent ? onLogoutClick() : 'false'">
                                {{ usermenu.name }}
                                <ng-container *ngIf="usermenu.displayInboxCount">
                                  ( {{ inboxCount }} ) </ng-container
                                ><i></i
                              ></a>
                            </h4>
                          </li>
                        </ng-container>
                      </ul>
                    </div>
                  </div>
                </ng-container>
                <!--END USER MENU-->
              </div>
            </div>
          </li>

          <!--END SIGNED IN USER MENU LINKS-->
        </ul>
        <!--HEADER MOBILE START-->
        <app-header-mobile
          (logoutClick)="onLogoutClick()"
          [messageInboxCount]="inboxCount"
          (clearDataStorage)="clearStorage()"></app-header-mobile>
        <!--HEADER MOBILE END-->
      </nav>
      <!--END NAVIGATION-->
    </div>
  </div>
</header>
<!--END HEADER-->
<div class="after-header" [ngStyle]="{ 'height.px': headerHeight }"></div>

<ng-template #viewFullCatalogButton>
  <div class="margin-top-small button-animate-white">
    <button
      routerLink="/search"
      (click)="toggleMenu(headerMenu.CATALOG)"
      href="javascript:void(0)"
      class="btn btn-brand btn-medium">
      View Full Catalog
    </button>
  </div>
</ng-template>
